/**
 * The logged-in user's roles are stored in `localStorage.ra_role` as whatever
 * the API returned — for a multi-role account that is an array coerced to a
 * string, e.g. `"SUPER_ADMIN,ADMIN"`. Comparing that string with `=== 'ADMIN'`
 * silently fails and such users lose UI they are entitled to (the "add
 * location" button, for one), so every role check goes through here.
 */
export const getRoles = (): string[] =>
  (localStorage.getItem('ra_role') ?? '')
    .split(',')
    .map((role) => role.trim())
    .filter(Boolean);

export const hasRole = (...roles: string[]): boolean => {
  const current = getRoles();
  return roles.some((role) => current.includes(role));
};

export const isAdminRole = (): boolean => hasRole('ADMIN', 'SUPER_ADMIN');
